import React from 'react'

const fieldFileProgress = ({ field }) => {
  const isFile = () => {
    return field.type === 'file'
  }

  if (!isFile()) {
    return null
  }

  if (typeof field.value === 'string') {
    return null
  }

  if (field.value.uploadDone || !field.isValid) {
    return null
  }

  let { percentComplete } = field.value
  percentComplete = parseInt(percentComplete, 10)
  return (
    <div style={{ position: 'absolute', width: '100%', top: 6 }}>
      <div
        style={{
          float: 'right',
          width: 100,
          height: 10,
          borderRadius: 4,
          border: '1px solid #ccc'
        }}>
        <div
          style={{
            padding: 2,
            float: 'left',
            height: 6,
            borderTopLeftRadius: 4,
            borderBottomLeftRadius: 4,
            borderBottomRightRadius: percentComplete > 98 ? 4 : 0,
            borderTopRightRadius: percentComplete > 98 ? 4 : 0,
            width: `calc(${percentComplete}% - 2px)`,
            backgroundColor: '#72ccb3'
          }}
        />
      </div>
    </div>
  )
}

export default fieldFileProgress



// WEBPACK FOOTER //
// ./src/components/inputs/fieldFileProgress.js